export default __webpack_public_path__ + "static/media/f_3.552b8640.jpg";